import React from 'react';
import { PATH } from '../../../../../constants';
import './ProjectInfo.css';
import { formatText } from '../../../../../utils/TextHelper';

const ProjectInfo = () => (
  <div id="about">
    <div id="about-wrap">
      <img
        id="about-title"
        src={`${PATH.IMG}title/o-projektu-page.png`}
        alt="O projektu"
      />
      <h2>REKONSTRUKCE OKUPACE</h2>
      <p className="about-strong">{formatText('Minulost stále trvá')}</p>
      <p>
        {formatText(
          'Dokumentarista Jan Šikl mnoho let vyhledává a sbírá soukromé filmové archivy. Zašlé a vybledlé osudy rodin, celuloidové ozvuky slavnostních i všedních okamžiků. Takto před časem narazil na několikahodinový materiál zachycující invazi vojsk Varšavské smlouvy do Československa v srpnu 1968. Záběry jedinečné, přesto patrně neviděné, vedou autora k pátrání po lidech v nich zachycených. Vzpomínky na konkrétní události ožívají a zkoumání se postupně mění v reflexi toho, jak se historický okamžik otiskl do nás samotných. Rekonstrukce okupace je film o zkušenosti mezní situace a svébytné formě společenské paměti.'
        )}
        <br />
        <br />
        {formatText(
          'Pátral však nejen filmový štáb, ale i diváci - součástí tvorby dokumentu Rekonstrukce okupace je i stejnojmenný webový projekt zahrnující množství archivních záběrů z 21.8.1968, ve kterých se diváci mohli pokusit najít sebe nebo své blízké, zároveň psát své komentáře a sdílet zážitky, které se odehrály před více než padesáti lety.'
        )}
        <br />
        <br />
        <strong>
          <a
            href="https://www.kviff.com/cs/program/film/57/33440-rekonstrukce-okupace"
            target="_blank"
            rel="noopener noreferrer"
          >
            {formatText('Světová premiéra na MFF Karlovy Vary 21.srpna 2021')}
          </a>
        </strong>
        <br />
        <br />
        {formatText('Štáb:')}
        <br />
        <br />
        {formatText('Scénář a režie: Jan Šikl')}
        <br />
        {formatText('Kamera: Adam Oľha')}
        <br />
        {formatText('Střih: Šimon Špidla')}
        <br />
        {formatText('Hudba: Jan Šikl ml.')}
        <br />
        {formatText('Zvuk: Martin Stýblo')}
        <br />
        {formatText('Dramaturgie: Lucie Králová')}
        <br />
        {formatText('Produkce: Martin Janoušek')}
        <br />
        <strong>
          {formatText('Kreativní producenti ČT: Alena Müllerová, Petr Kubica')}
        </strong>
        <br />
        <strong>{formatText('Producent RTVS: Roman Genský')}</strong>
        <br />
        {formatText('Producentky PubRes: Zuzana Mistríková, ')}
        <strong>{formatText('Ľubica Orechovská')}</strong>
        <br />
        {formatText('Producentka Cinepoint: Alice Tabery')}
      </p>
      <div className="about-small">
        <p className="about-strong">Poděkování:</p>
        <p>
          Dramaturgie, webová produkce, grafika a webdesign, programování –
          Centrum dramaturgie nových médií ČT: Josef Duda, Filip Smetana,
          Kateřina Sudolská, Štěpánka Sunková, Petr Šprincl
        </p>
      </div>
      <br />
      <p>
        Jan Šikl
        <br />
        autor, režisér
        <br />
        <a
          className="about-strong"
          href="https://pragafilm.cz/"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.pragafilm.cz
        </a>
        <br />
        <a className="about-strong" href="mailto:Jan@pragafilm.cz">
          Jan@pragafilm.cz
        </a>
        <br />
        608 250 005
      </p>
      <div id="about-logos-wrap">
        <img src={`${PATH.IMG}vary/logo-kv.png`} alt="Karlovy Vary" />
        <img
          id="logo-prix"
          src={`${PATH.IMG}prix-italia.png`}
          alt="Prix Italia 71"
        />
      </div>
    </div>
  </div>
);

export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/ProjectInfo/ProjectInfo.js